import resultsMessages from '@rhg/lang/messages/results';
import {
    ScreeningResult,
    screeningResultColors,
} from '@rhg/utils/usercrypt/checkins';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export interface Scale {
    label: string;
    color: string;
}

export function useScreeningResultsScales() {
    const { formatMessage } = useIntl();

    const gadScales = useMemo<Scale[]>(
        () => [
            {
                label: formatMessage(
                    resultsMessages['results.gad_info.scales.minimal']
                ),
                color: screeningResultColors.subclinical,
            },
            {
                label: formatMessage(
                    resultsMessages['results.gad_info.scales.mild']
                ),
                color: screeningResultColors.mild,
            },
            {
                label: formatMessage(
                    resultsMessages['results.gad_info.scales.moderate']
                ),
                color: screeningResultColors.moderate,
            },
            {
                label: formatMessage(
                    resultsMessages['results.gad_info.scales.severe']
                ),
                color: screeningResultColors.severe,
            },
        ],
        [formatMessage]
    );

    const phqScales = useMemo<Scale[]>(
        () => [
            {
                label: formatMessage(
                    resultsMessages['results.phq_info.scales.minimal']
                ),
                color: screeningResultColors.subclinical,
            },
            {
                label: formatMessage(
                    resultsMessages['results.phq_info.scales.mild']
                ),
                color: screeningResultColors.mild,
            },
            {
                label: formatMessage(
                    resultsMessages['results.phq_info.scales.moderate']
                ),
                color: screeningResultColors.moderate,
            },
            {
                label: formatMessage(
                    resultsMessages['results.phq_info.scales.moderately_severe']
                ),
                color: screeningResultColors[ScreeningResult.ModerateSevere],
            },
            {
                label: formatMessage(
                    resultsMessages['results.phq_info.scales.severe']
                ),
                color: screeningResultColors.severe,
            },
        ],
        [formatMessage]
    );

    return {
        gadScales,
        phqScales,
    };
}
